import {Checkbox, FormGroup} from "../../@coherent/react-hook-form";
import React from "react";

export const CheckboxOption = ({label, name, disabled, onChange }) => {
  return (
    <FormGroup htmlFor={name} className="mb-0" check label={label}>
      <Checkbox onChange={onChange} disabled={disabled} id={name} name={name} className="form-check-input"/>
    </FormGroup>
  )
}